import React from 'react';
import { Button, Container, Flex } from '@tishman/components';
import { VisuallyHidden } from '@reach/visually-hidden';
import * as Icons from '@tishman/icons';

type TPrivateEventsGalleryArrows = {
  beginning: boolean;
  handlePrevious: () => void;
  end: boolean;
  handleNext: () => void;
};

export const PrivateEventsGalleryArrows = ({
  beginning,
  handlePrevious,
  end,
  handleNext,
}: TPrivateEventsGalleryArrows) => {
  return (
    <Container
      sx={{
        alignSelf: 'center',
        display: 'flex',
        justifyContent: 'flex-end',
        mb: [2, 4],
        mr: 'auto',
        ml: 'auto',
        maxWidth: '1440px',
        paddingRight: ['8px', 0],
      }}
    >
      <Flex
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          position: 'sticky',
        }}
      >
        <Button
          data-element="CarouselNavigationPrevious"
          disabled={beginning}
          onClick={handlePrevious}
          sx={{
            'cursor': 'pointer',
            ':not(:disabled):hover svg': {
              transform: `translateX(-5px) scale(${24 / 18}) rotate(180deg)`,
            },
          }}
          tabIndex={0}
          variant="icon"
        >
          <VisuallyHidden>Previous Item</VisuallyHidden>
          <Icons.Arrow
            aria-hidden
            style={{
              transition: 'transform 0.3s ease-in-out',
              transform: `scale(${24 / 18}) rotate(180deg)`,
            }}
          />
        </Button>
        <Button
          data-element="CarouselNavigationNext"
          disabled={end}
          onClick={handleNext}
          sx={{
            'cursor': 'pointer',
            ':not(:disabled):hover svg': {
              transform: `translateX(5px) scale(${24 / 18}) `,
            },
          }}
          tabIndex={0}
          variant="icon"
        >
          <VisuallyHidden>Next Item</VisuallyHidden>
          <Icons.Arrow
            aria-hidden
            style={{
              transition: 'transform 0.3s ease-in-out',
              transform: `scale(${24 / 18})`,
            }}
          />
        </Button>
      </Flex>
    </Container>
  );
};
